import { SessionHelperOptions } from "../session/SessionStorageInterface.js";
import { DirectLoginManagerConfig } from "../login/DirectLoginManagerConfig.js";
import { PushNotificationServiceConfig } from '../subscriptions/PushNotificationServiceConfig.js';
import { UrlBuilderConfig } from "../sdk/modules/impl/ApplicationUrlHandlerDefaultImpl.js";
import { PropertyConfig, ServicePathsMapping } from "./PropertyConfig.js";

export class ConfigHelper {
    constructor(private config: PropertyConfig) {

    }

    public getPushNotificationHelperConfig(): PushNotificationServiceConfig {
        return {
            version: this.config.version,
            firebase: this.config.loginManager.firebase,
            vapiKey: this.config.webPush.vapiKey,
            workerUrl: this.getServiceWorkerUrl(),
            mainUrl: this.config.mainUrl
        };
    }


    public getDirectLoginManagerConfig(withAppToken: string): DirectLoginManagerConfig {
        return {
            actual_providers: this.config.loginManager.actual_providers,
            firebase: this.config.loginManager.firebase,
            general: {
                app_token: withAppToken,
                firebaseAccountMergeEnable: this.config.loginManager.firebaseAccountMergeEnable
            },
            autologin: this.config.loginManager.autologin,
            revokeOnClientSideOnDeletion: this.config.loginManager.revokeOnClientSideOnDeletion,
            mainUrl: this.config.mainUrl
        };
    }


    public getSessionStorageConfig(): SessionHelperOptions {
        return {
            monitorFrequency: 500
        };
    }
  

    private getDefaultServicePaths(): ServicePathsMapping {
        return {
            basepath: "/user",
            settings: "/user/settings",
            login: "/user/login",
            notifications: "/user/notifications",
            follow: "/user/follow",
            bookmarks: "/user/bookmarks",
            cardEdit: "/user/cardEdit",
            cardView: "/user/cardView"
        };
    }

    public getServicePathsMapping(): ServicePathsMapping {
        const override = this.config.servicePaths ? this.config.servicePaths : {};
        return {
            ...(this.getDefaultServicePaths()),
            ...override
        };
    }

    public getUrlBuilderConfig(): UrlBuilderConfig {
        return {
            servicePaths: this.getServicePathsMapping(),
            secure: this.config.secure,
            host: this.config.host
        };
    }

    
    public getOriginal(): PropertyConfig {
        return this.config;
    }

    public getSdkJsServerUrl(): string {
        return "http" + (this.config.sdkJsServer.secure?"s":"") + "://" + this.config.sdkJsServer.host + this.config.sdkJsServer.path;
    }

    private getServiceWorkerUrl(): string {
        return "http" + (this.config.secure?"s":"") + "://" + this.getServiceWorkerHost() + this.config.webPush.serviceWorkerPath;
    }

    private getServiceWorkerHost(): string {
        const rval = this.config.webPush.serviceWorkerHost?this.config.webPush.serviceWorkerHost:this.config.host;
        return rval == "SameHost" ? document.location.host : rval;
    }
}